import { IRootState } from "redux/reducer";
import { IDownload, IDownloadsList } from "./types";

//analytics
export const getAnalyticsCsvDownloadsList = (state: IRootState): IDownload[] =>
  Object.values(state.analyticsCsvDownloads.list as IDownloadsList).sort(
    (a, b) => b.addedTS - a.addedTS
  );
export const isAnalyticsDownloadsModalOpened = (
  state: IRootState
): boolean | undefined => state.analyticsCsvDownloads.isModalOpened;

//traffic
export const getTrafficCsvDownloadsList = (state: IRootState): IDownload[] =>
  Object.values(state.trafficCsvDownloads.list as IDownloadsList).sort(
    (a, b) => b.addedTS - a.addedTS
  );
export const isTrafficDownloadsModalOpened = (
  state: IRootState
): boolean | undefined => state.trafficCsvDownloads.isModalOpened;

export type TDownloadKind = "analytics" | "traffic";
export interface IUnifiedDownload extends IDownload {
  kind: TDownloadKind;
}

export const getAllCsvDownloadsList = (state: IRootState): IUnifiedDownload[] => {
  const analytics = getAnalyticsCsvDownloadsList(state).map(d => ({ ...d, kind: 'analytics' as const }));
  const traffic = getTrafficCsvDownloadsList(state).map(d => ({ ...d, kind: 'traffic' as const }));

  return [...analytics, ...traffic]
    .sort((a, b) => b.addedTS - a.addedTS);
};

export const isAllDownloadsModalOpened = (
  state: IRootState
): boolean | undefined => state.allCsvDownloads?.isModalOpened;
